module.exports = __webpack_public_path__ + "static/media/Backgorund.32ad1d20.mp4";